(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // Loop through each slideshow section initialized by Liquid
  const slideshowSections = document.querySelectorAll('[data-init-slideshow]');
  slideshowSections.forEach(function(slideshowElement) {
    // Get settings from data attributes added by Liquid
    const autoplay = slideshowElement.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = parseInt(slideshowElement.getAttribute('data-autoplay-speed'), 10) || 5000; // Default to 5000ms
    const fade = slideshowElement.getAttribute('data-fade') === 'true';
    const dots = slideshowElement.getAttribute('data-dots') === 'true';
    const autoPlayVideo = slideshowElement.getAttribute('data-auto-video') === 'true';

    // Initialize Slick Slider with the retrieved settings
    const $slideshow = $(slideshowElement); // Convert to jQuery object for Slick
    $slideshow.slick({
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      fade: fade,
      dots: dots,
      arrows: true, // Arrows are styled via CSS, assume always present
      infinite: true,
      speed: 500, // Adjust transition speed if needed
      slidesToShow: 1,
      slidesToScroll: 1,
      // Optional: Add lazy loading if images are heavy
      // lazyLoad: 'ondemand', // Requires img data-lazy attribute
      responsive: [
        {
          breakpoint: 768, // Adjust breakpoint as needed
          settings: {
            dots: true // Force dots on mobile if needed, or adjust based on design
            // Add other mobile-specific settings here if required by Slick
          }
        }
        // Add more breakpoints if necessary
      ]
    });

    // --- Video Handling ---
    // Function to pause HTML5 video
    function pauseHtml5Video(slide) {
      const video = slide.querySelector('video');
      if (video && !video.paused) {
        video.pause();
      }
    }

    // Function to play HTML5 video (if autoplay is enabled)
    function playHtml5Video(slide) {
      const video = slide.querySelector('video');
      if (video && autoplay && autoPlayVideo) {
         // Muted autoplay is generally required
        video.muted = true;
        video.play().catch(e => console.log("Autoplay video failed:", e));
      }
    }

    // Function to pause YouTube video (requires YouTube Iframe API)
    // This is a basic implementation. For robust control, load the YT API properly.
    function pauseYoutubeVideo(slide) {
      const iframe = slide.querySelector('iframe.youtube-player');
      if (iframe) {
        const player = iframe.contentWindow;
        player.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }
    }

    // Function to attempt playing YouTube video (requires YouTube Iframe API)
    // Muting might be necessary for autoplay. Basic play attempt shown.
    function playYoutubeVideo(slide) {
      const iframe = slide.querySelector('iframe.youtube-player');
      if (iframe && autoplay && autoPlayVideo) {
        const player = iframe.contentWindow;
        // Send message to mute and play (basic approach)
        player.postMessage('{"event":"command","func":"mute","args":""}', '*');
        player.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      }
    }

    // On slide change, manage video playback
    $slideshow.on('beforeChange', function(event, slick, currentSlideIndex, nextSlideIndex) {
       const currentSlide = slick.$slides[currentSlideIndex];
       const nextSlide = slick.$slides[nextSlideIndex];

       // Pause videos in the slide that is leaving
       pauseHtml5Video(currentSlide);
       pauseYoutubeVideo(currentSlide);

       // Prepare to play videos in the slide that is entering (if autoplay is on)
       // Use a tiny delay to ensure the slide is mostly transitioned
       setTimeout(() => {
          playHtml5Video(nextSlide);
          playYoutubeVideo(nextSlide);
       }, 100); // Adjust delay if needed

    });

    // Handle initial load - play video on the first slide if autoplay is on
    if ($slideshow.slick('getSlick').$slides.length > 0) {
       const firstSlide = $slideshow.slick('getSlick').$slides[0];
       // Use a small delay to ensure the slide is fully rendered
       setTimeout(() => {
           playHtml5Video(firstSlide);
           playYoutubeVideo(firstSlide);
       }, 500); // Adjust delay if needed
    }

    // Optional: Handle window resize if video aspect ratio needs adjustment
    // $(window).on('resize', function() {
    //   // Recalculate video wrapper padding if necessary
    //   // Or trigger Slick's resize handler: $slideshow.slick('setPosition');
    // });

  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // class StickyHeader extends HTMLElement {
  //   constructor() {
  //     super();
  //   }

  //   connectedCallback() {
  //     this.header = document.querySelector('.section-header');
  //     this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
  //     this.headerBounds = {};

  //     this.setHeaderHeight();

  //     window.matchMedia('(max-width: 1330px)').addEventListener('change', this.setHeaderHeight.bind(this));

  //     if (this.headerIsAlwaysSticky) {
  //       this.header.classList.add('shopify-section-header-sticky');
  //     };

  //     this.currentScrollTop = 0;
  //     this.preventReveal = false;
  //     this.predictiveSearch = this.querySelector('predictive-search');

  //     this.onScrollHandler = this.onScroll.bind(this);
  //     this.hideHeaderOnScrollUp = () => this.preventReveal = true;

  //     this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  //     window.addEventListener('scroll', this.onScrollHandler, false);

  //     this.createObserver();
  //   }

  //   setHeaderHeight() {
  //     document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  //   }

  //   disconnectedCallback() {
  //     this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  //     window.removeEventListener('scroll', this.onScrollHandler);
  //   }

  //   createObserver() {
  //     let observer = new IntersectionObserver((entries, observer) => {
  //       this.headerBounds = entries[0].intersectionRect;
  //       observer.disconnect();
  //     });

  //     observer.observe(this.header);
  //   }

  //   onScroll() {
  //     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  //     if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

  //     if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  //       this.header.classList.add('scrolled-past-header');
  //       if (this.preventHide) return;
  //       requestAnimationFrame(this.hide.bind(this));
  //     } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  //       this.header.classList.add('scrolled-past-header');
  //       if (!this.preventReveal) {
  //         requestAnimationFrame(this.reveal.bind(this));
  //       } else {
  //         window.clearTimeout(this.isScrolling);

  //         this.isScrolling = setTimeout(() => {
  //           this.preventReveal = false;
  //         }, 66);

  //         requestAnimationFrame(this.hide.bind(this));
  //       }
  //     } else if (scrollTop <= this.headerBounds.top) {
  //       this.header.classList.remove('scrolled-past-header');
  //       requestAnimationFrame(this.reset.bind(this));
  //     }

  //     this.currentScrollTop = scrollTop;
  //   }

  //   hide() {
  //     if (this.headerIsAlwaysSticky) return;
  //     this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  //     this.closeMenuDisclosure();
  //     this.closeSearchModal();
  //   }

  //   reveal() {
  //     if (this.headerIsAlwaysSticky) return;
  //     this.header.classList.add('shopify-section-header-sticky', 'animate');
  //     this.header.classList.remove('shopify-section-header-hidden');
  //   }

  //   reset() {
  //     if (this.headerIsAlwaysSticky) return;
  //     this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  //   }

  //   closeMenuDisclosure() {
  //     this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
  //     this.disclosures.forEach(disclosure => disclosure.close());
  //   }

  //   closeSearchModal() {
  //     this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  //     this.searchModal.close(false);
  //   }
  // }

  // customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index_FAQ_section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".faq-item");

  faqItems.forEach((item) => {
    const question = item.querySelector(".faq-question");
    const answer = item.querySelector(".faq-answer");

    question.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      faqItems.forEach((otherItem) => {
        otherItem.classList.remove("active");
        otherItem.querySelector(".faq-answer").style.maxHeight = null;
      });

      if (!isActive) {
        item.classList.add("active");
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();
})();
